import { useQuery } from "@tanstack/react-query";

import { supabase } from "@/shared/lib/supabase";

export function useCountyFromZip(zipCode: string | null | undefined) {
  return useQuery({
    queryKey: ["countyFromZip", zipCode],
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke("legal/county-by-zip", {
        body: { zipcode: zipCode },
      });
      if (error) throw error;
      return (data?.county as string) ?? null;
    },
    enabled: !!zipCode,
    staleTime: Infinity,
  });
}
